import { createApp } from 'vue';
import eventBus from '@tools/event-bus';
import { URL_USER_OFFERS } from '@tools/routes/routes';
import sendEmailValidation from '@atoms/send-email-validation';

/**
 * Init State Bar Component
 */
export default function () {
  const component = {
    delimiters: [ '${', '}' ],
    data() {
      return {
        showStateBar: false,
        state: false,
        offerHashId: window.offer_id,
        offer: false,
        info: '',
      };
    },
    mixins: [ sendEmailValidation ],
    mounted() {
      const element = document.getElementById('state-bar');
      const stateBar = {
        ...JSON.parse(element.dataset.statebar),
      };

      if (!stateBar.state) {
        return;
      }

      this.showStateBar = true;
      this.state = stateBar.state;
      this.offer = stateBar.offer;
      this.info = stateBar.info;
    },
    methods: {
      isPublishable() {
        return !!this.offer && this.offer.publishable;
      },
      isEditable() {
        return !!this.offer && this.offer.editable;
      },
      isUnpublishable() {
        return !!this.offer && this.offer.unpublishable;
      },
      isDeletable() {
        return !!this.offer && this.offer.deletable;
      },
      /**
       * This method displays the delete offer modal.
       */
      showDeleteModal() {
        eventBus.dispatchEvent(new CustomEvent('offer-delete', {
          detail: {
            offerHashId: this.offerHashId,
            redirectUrl: URL_USER_OFFERS,
          },
        }));
      },
      /**
       * This method displays the unpublish offer modal.
       */
      showUnpublishModal() {
        eventBus.dispatchEvent(new CustomEvent('offer-unpublish', { detail: { offerHashId: this.offerHashId } }));
      },
      /**
       * This method call action to review offer.
       */
      review() {
        eventBus.dispatchEvent(new CustomEvent('offer-review', {
          detail: {
            offerHashId: this.offerHashId,
            element: this.$el.querySelector('.review-button'),
          },
        }));
      },
      /**
       * Normally, the href is already defined in the backend by getEditUrl @see OfferRoutingHelper
       * But in some case, the url of setup form can't be defined in the backend
       *  (e.g when the state is expired, or unpublished)
       * So in those cases, we let @see offer/actions.js do the work
       */
      edit(event) {
        // this means href has not been defined by backend, it is basically current url (modulo some params or anchor)
        if (!window.location.href.includes(event.currentTarget.href)) {
          event.stopPropagation();

          return;
        }

        eventBus.dispatchEvent(new CustomEvent('offer-special-edit', { detail: this.offerHashId }));
        event.preventDefault();
      },
    },
    template: '#state-bar-template',
  };

  return createApp(component).mount('#state-bar-app');
}
